import React from "react";
function AllResultsContainer(props) {
  return (
    <React.Fragment>
      {props.hideSearch ? (
        ""
      ) : (
        <div>
          <input
            aria-label={props.ariaLabel}
            disabled={props.loading}
            name="searchString"
            onChange={props.inputHandleOnChange}
            className="input"
            placeholder={ props.placeholder || "Search (school, district, address)"}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
        </div>
      )}
      {props.children}
    </React.Fragment>
  );
}

export default AllResultsContainer;
